import { render, staticRenderFns } from "./adminProjectSheet.vue?vue&type=template&id=07af831c"
import script from "./adminProjectSheet.vue?vue&type=script&lang=js"
export * from "./adminProjectSheet.vue?vue&type=script&lang=js"
import style0 from "./adminProjectSheet.vue?vue&type=style&index=0&id=07af831c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports